import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Select, Divider, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import { fetchData, sendData } from '../../httpRequests';
import { getPharmacyId } from '../../components/Shared';
import CreatePharmacy from './CreatePharmacy';

const { Search } = Input;
const { Option } = Select;

export default function AdminPharmacies() {
	const navigate = useNavigate();
	const [filteredPharmacies, setFilteredPharmacies] = useState([]);
	const [pharmacies, setPharmacies] = useState([]);

	useEffect(() => {
		const pharmacyId = getPharmacyId();
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		checkUserAdmin(pharmacyId);

		const url = '/pharmacies/getPharmaciesSelect';
		fetchData(url).then((response) => {
			if (Object.keys(response).length > 0) {
				const pharmacies = response['pharmacy'];
				setPharmacies(pharmacies);
				setFilteredPharmacies(pharmacies);
			}
		});
		return () => {
			setPharmacies([]);
			setFilteredPharmacies([]);
		};
	}, []);

	const checkUserAdmin = (pharmacyId) => {
		const url = '/pharmacies/getPharmacyById';
		const data = {
			id: pharmacyId
		};
		sendData(url, data).then((response) => {
			const pharmacy = response['pharmacy'];
			if (pharmacy.role_id != 4&&pharmacy.role_id!=5) navigate('/orders');
		});

		return false;
	};

	const onSearch = (value) => {
		const text = value.target.value;
		setTimeout(() => {
			if (text) {
				const filteredPharmacies = pharmacies.filter(
					(pharmacy) =>
						pharmacy.npi.includes(text) ||
						pharmacy.zip.includes(text) ||
						pharmacy.city.toLowerCase().includes(text.toLowerCase()) ||
						pharmacy.name.toLowerCase().includes(text.toLowerCase())
				);
				setFilteredPharmacies(filteredPharmacies);
			} else {
				setFilteredPharmacies(pharmacies);
			}
		}, 1000);
	};

	const handleChange = (value) => {
		if (value) {
			const filteredPharmacies = pharmacies.filter((pharmacy) => pharmacy.status == value);
			setFilteredPharmacies(filteredPharmacies);
		} else {
			setFilteredPharmacies(pharmacies);
		}
	};

	const columns = [
		{ title: 'NPI', dataIndex: 'npi', key: 'npi' },
		{ title: 'Name', dataIndex: 'name' },
		{ title: 'Secret key', dataIndex: 'secret_key' },
		{ title: 'Security code', dataIndex: 'security_code' },
		{ title: 'Owner email', dataIndex: 'owner_email' },
		{ title: 'City', dataIndex: 'city' },
		{ title: 'Zip code', dataIndex: 'zip' }
	];

	return (
		<div>
			<Row gutter={24}>
				<Col span={9}>
					<Search
						size='large'
						placeholder='Search pharmacy by npi, name, city or zip code'
						onChange={onSearch}
					/>
				</Col>
				<Col span={9}>
					<Select
						placeholder='Select status'
						defaultValue={''}
						size='large'
						onChange={handleChange}
						style={{ width: '100%' }}
					>
						<Option value=''>All</Option>
						<Option value='1'>Active</Option>
						<Option value='2'>Pending</Option>
					</Select>
				</Col>
				<Col  span={6}>
				<CreatePharmacy />
				</Col>
			</Row>
			<Divider />
			<Row gutter={24}>
				<Col span={24}>
					<Table
						columns={columns}
						dataSource={filteredPharmacies}
						rowKey={(item) => item.id}
						onRow={(record) => {
							return {
								onClick: () => navigate('/admin/pharmacyDetails/' + record.id)
							};
						}}
					/>
				</Col>
			</Row>
		</div>
	);
}
